import { render, staticRenderFns } from "./ModalPasienUpdate.vue?vue&type=template&id=361cdbc1"
import script from "./ModalPasienUpdate.vue?vue&type=script&lang=js"
export * from "./ModalPasienUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports